import { type FC } from 'react';
import { useBoostFirebaseEvents } from '@common/hooks/boost-firebase-events';
import { type PlantType } from '@common/types/common';
import { type FactoryTypeText } from '@common/types/factory';
import { type PlantTypeText } from '@common/types/plant';
import { type ResourceTypeText } from '@common/types/resource';
import {
  selectActiveBoostForFactory,
  selectAdsBoostForFactory,
  selectBoostX5ForFactory,
  selectBoostX10ForFactory,
  selectFactories,
  selectFreeBoostForFactory,
  selectPaidBoostForFactory,
  selectTotalFactoryBoostById,
  selectVipBoostForFactory,
} from '@redux/selectors/factoryReducer';
import { useAppSelector } from '@redux/store';

import { type GoodsType } from '@/common/types/goods';
import { BoostFirebaseEventsContext } from '@/context/BoostFirebaseEventContext';

import { BoostCardList } from './BoostCardList/BoostCardList';

interface BoostFactoryProps {
  plantType: PlantType;
  plantId: string;
  plant: PlantTypeText | ResourceTypeText | FactoryTypeText;
  item: PlantTypeText | ResourceTypeText | GoodsType;
  level: number;
}

const BoostFactory: FC<BoostFactoryProps> = ({
  plantId,
  plant,
  plantType,
  level,
  item,
}) => {
  const freeBoost = useAppSelector((state) =>
    selectFreeBoostForFactory(state, plantId),
  );
  const adsBoost = useAppSelector((state) =>
    selectAdsBoostForFactory(state, plantId),
  );
  const vipBoost = useAppSelector((state) =>
    selectVipBoostForFactory(state, plantId),
  );
  const paidBoost = useAppSelector((state) =>
    selectPaidBoostForFactory(state, plantId),
  );
  const boostX5 = useAppSelector((state) =>
    selectBoostX5ForFactory(state, plantId),
  );
  const boostX10 = useAppSelector((state) =>
    selectBoostX10ForFactory(state, plantId),
  );
  const totalBoost = useAppSelector((state) =>
    selectTotalFactoryBoostById(state, plantId),
  );
  const factoriesList = useAppSelector(selectFactories);
  const activeBoost = useAppSelector(selectActiveBoostForFactory);
  const events = useBoostFirebaseEvents(
    { id: plantId, level, name: plant },
    activeBoost,
    factoriesList,
  );

  return (
    <BoostFirebaseEventsContext.Provider value={events}>
      <BoostCardList
        item={item}
        plant={plant}
        plantId={plantId}
        plantType={plantType}
        forAllPlantlist={[freeBoost, vipBoost]}
        forCurrentPlantList={[adsBoost, paidBoost, boostX5, boostX10]}
        totalBoost={totalBoost}
        level={level}
      />
    </BoostFirebaseEventsContext.Provider>
  );
};

export { BoostFactory };
